import React, { Component } from 'react'
import { connect } from 'react-redux'
import { InstructionsComponent } from '../components'

class Instructions extends Component {


    goToScreen = (key, params) => {
        this.props.history.push({
            pathname: key,
            params: params,
        })
    }

    goBack = () => {
        this.props.history.replace("language")
    }

    render() {
        const { language, languageJSON, requestState } = this.props
        return (
            <InstructionsComponent
                goBack={this.goBack}
                goToScreen={this.goToScreen}
                language={language}
                languageJSON={languageJSON}
                requestDetails={requestState.requestParams || {}}
            />
        )
    }
}

const mapStateToProps = ({ language: { language, languageJSON }, shared: { requestState } }) => ({
    language,
    languageJSON,
    requestState
})

export default connect(mapStateToProps)(Instructions)
